import PaperLayout from "./PaperLayout";
export default PaperLayout;
